<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-percentage`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zM6 24c0 9.941 8.059 18 18 18a17.94 17.94 0 0012.553-5.1L22 24.945V6.11C13 7.104 6 14.735 6 24zM26 6.11v16.945L39.094 33.81A17.916 17.916 0 0042 24c0-9.265-7-16.895-16-17.89z"/></svg>
</template>
<script>

export default {
  name: 'IconPercentage',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
